<template>
  <div class="animated">
    <v-client-table
      id="analyte-table"
      :columns="columns"
      :data="analytes"
      :options="options"
      :theme="theme"
      class="w-100"
    >
      <span
        v-if="showColumn('sample_type')"
        slot="sample_type"
        slot-scope="{ row }"
      >
        {{ row.sample_type.name }}
      </span>

      <span v-if="showColumn('name')" slot="name" slot-scope="{ row }">
        <a :href="`#/analytes/${row.id}`" class="btn-link">{{ row.name }}</a>
      </span>

      <span v-if="showColumn('abbrev')" slot="abbrev" slot-scope="{ row }">
        <a :href="`#/analytes/${row.id}`" class="btn-link">{{ row.abbrev }}</a>
      </span>

      <span
        v-if="showColumn('modus_name')"
        slot="modus_name"
        slot-scope="{ row }"
      >
        <a :href="`#/analytes/${row.id}`" class="btn-link">
          {{ row.modus_name }}
        </a>
      </span>

      <span
        v-if="showColumn('description')"
        slot="description"
        slot-scope="{ row }"
      >
        {{ row.description }}
      </span>
    </v-client-table>
  </div>
</template>

<script>
import Vue from 'vue'
import { ClientTable } from 'vue-tables-2'

Vue.use(ClientTable)

export default {
  name: 'AnalyteTable',
  components: {
  },
  props: {
    analytes: {
      type: Array
    },
    show_columns: {
      type: Array,
      default: () => [
        'sample_type',
        'name',
        'modus_name',
        'abbrev',
        'description'
      ]
    },
    filterable: {
      type: Array,
      default: () => ['sample_type', 'name', 'abbrev', 'modus_name']
    },
    sortable: {
      type: Array,
      default: () => ['sample_type', 'name', 'abbrev', 'modus_name']
    }
  },
  data () {
    return {
      columns: this.show_columns,
      data: this.analytes,
      options: {
        headings: {
          sample_type: 'Sample Type',
          name: 'Analyte Name',
          abbrev: 'Abbrev',
          modus_name: 'MODUS'
        },
        sortable: this.sortable,
        filterable: this.filterable,
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        pagination: {
          chunk: 5,
          edge: false,
          nav: 'scroll'
        }
      },
      useVuex: false,
      theme: 'bootstrap4',
      template: 'default'
    }
  },
  methods: {
    /**
     * Check if the column should be shown
     * @param key
     * @return boolean
     */
    showColumn (key) {
      return this.show_columns.indexOf(key) !== -1
    }
  }
}
</script>
